import React from "react";
import PropTypes from "prop-types";
import "../Help.css";

const HorizontalLine = () => {
  return (
    <div className="hr"></div>
  );
};


export default HorizontalLine;



// WEBPACK FOOTER //
// ./src/components/help/HorizontalLine/index.js